const VIDEOS = {
    MAIN: require('src/assets/videos/with.mp4'),
    MAIN_PC: require('src/assets/videos/w.mp4'),
    MAIN_MOBILE: require('src/assets/videos/m.mp4'),
    

};

export default VIDEOS;
